import React from "react";
import PropTypes from "prop-types";

import { gatherClasses } from "../../lib/utils";
import Spinner from "../spinner/spinner";
import "./loader.scss";

const Loader = props => {
  /**
   * If opacity is set by user then honour it
   * Else if loader is Invert then set 0.5 otherwise set 0.8
   */
  const {
    opacity: propOpacity,
    invert,
    noOverlay,
    dataTestId,
    isLoading,
    fullPage,
    showIcon,
    iconSize,
    text,
    children
  } = props;
  let opacity = propOpacity || (invert ? 0.5 : 0.8);
  opacity = noOverlay ? 0 : opacity;
  const background = invert
    ? `rgba(0,0,0,${opacity})`
    : `rgba(255,255,255,${opacity})`;
  return (
    <div
      data-testid={dataTestId}
      className={gatherClasses(
        props,
        isLoading ? "oui-loader oui-show" : "oui-loader",
        invert ? "oui-loader-invert" : null,
        fullPage ? "oui-full-page" : null
      )}
    >
      <div
        className={gatherClasses(null, "oui-loader-content")}
        style={{ background }}
      >
        {showIcon ? <Spinner className="loader-icon" size={iconSize} /> : null}
        {text ? <div className="oui-loader-text">{text}</div> : null}
      </div>
      {children}
    </div>
  );
};

Loader.propTypes = {
  isLoading: PropTypes.bool,
  showIcon: PropTypes.bool,
  text: PropTypes.string,
  fullPage: PropTypes.bool,
  invert: PropTypes.bool,
  noOverlay: PropTypes.bool,
  iconSize: PropTypes.oneOf(["sm", "md", "lg"]),
  opacity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dataTestId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

Loader.defaultProps = {
  isLoading: false,
  showIcon: true,
  text: null,
  fullPage: false,
  invert: false,
  noOverlay: false,
  iconSize: "md",
  dataTestId: "orion-loader"
};

Loader.displayName = "OrionLoader";

export default Loader;
